module.exports = __webpack_public_path__ + "static/media/logo-violet.89e7f070.svg";